<template>
  <div>
    <ipub-form ref="author-submit-manuscripts-information-form"
               :model="params"
               :rules="rules">
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="journalId"
                          label="Journal">
            <!-- <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         :disabled="$route.path.includes('/editorial-office')"
                         @change="(e)=>{onJournalChange(e, true)}"
                         optionTitle="fullName"
                         :options="journalList" /> -->
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         :disabled="$route.path.includes('/editorial-office')"
                         @change="(e)=>{onJournalChange(e, true)}">

              <!-- v-show="!nonJournal.includes(item.name)" -->
              <ipub-select-option v-for="(item,index) in journalList"
                                  :key="item.id"
                                  :value="item.id">
                {{item.fullName}}
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="typeCode"
                          label="Article Type">
            <ipub-select v-model="params.typeCode"
                         optionKey="code"
                         placeholder="Select Article Type">
              <ipub-select-option v-for="item in articleTypeList"
                                  :value="item.code"
                                  :key="item.code">
                {{item.name}}
                <template v-if="item.otherName">({{item.otherName}})</template>
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
      </ipub-row>

      <ipub-row :gutter="20">
        <ipub-col :span="journalInfo.displaySection?6:12">
          <ipub-form-item prop="specialId"
                          label="Special Issue (Optional)">
            <ipub-select v-model="params.specialId"
                         search
                         :clear="true"
                         @search="getSpecial"
                         @change="onSpecialSelect"
                         optionTitle="titleText"
                         placeholder="Select Special Issue"
                         :options="specialIssueList" />
            <div class="ipub-p4"
                 v-if="params.specialId&&special&&special.id">
              Deadline for manuscript submissions:
              <font class="key-color">{{$moment(special.endTime).format('DD / MM / YYYY')}}</font>
            </div>
          </ipub-form-item>
        </ipub-col>
        <ipub-col v-if="journalInfo.displaySection"
                  :span="6">
          <ipub-form-item prop="sectionId"
                          label="Section (Optional)">
            <ipub-select v-model="params.sectionId"
                         :tree="true"
                         :clear="true"
                         placeholder="Select Section"
                         :options="sectionList" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>

      <!-- <ipub-row :gutter="20">
        <ipub-col :span="12">
          <ipub-form-item prop="collections"
                          label="Collections">
            <ipub-select v-model="params.collections"
                         placeholder="Select Collections"
                         :options="collectionsList" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row> -->

      <ipub-form-item prop="title"
                      label="Title">
        <ipub-input v-model.trim="params.title"
                    placeholder="Title" />
      </ipub-form-item>

      <ipub-form-item prop="summary"
                      label="Abstract">
        <ipub-textarea v-model.trim="params.summary"
                       placeholder="Abstract"
                       style="height:120px" />
      </ipub-form-item>

      <ipub-form-item prop="keywords"
                      label="Keywords">
        <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                    tag
                    v-model.trim="params.keywords" />
      </ipub-form-item>

      <div class="mar-b-20">
        <div class="ipub-p2"
             v-if="params.sign && params.sign>1">
          <span class="ipub-block__span fw-bd"
                style="width:80px">discount:</span>
          <span class="ipub-block__font">
            <template v-if="discountCodeList && discountCodeList.length>0">
              <font v-for="(item) in discountCodeList"
                    :key="item.id">$ {{item.discount}} off; </font>
            </template>
            <template v-else>- -</template>
          </span>
        </div>
        <div v-else>
          <ipub-radio :checked="hasDiscount"
                      class="mar-b-10 ipub-p1"
                      @change="()=>{hasDiscount = !hasDiscount}"
                      label="I have a discount code" />
          <ipub-tooltip placement="right"
                        type="dark"
                        class="mar-l-10 ipub-p1">
            <div slot="title">
              <div class="ipub-p4">
                <a target="_blank"
                   style="text-decoration:underline;"
                   href="https://www.imrpress.com/resources/for_reviewers">How to get a discount voucher?</a>
              </div>
            </div>
            <ipub-icon type="iconInfo" />
          </ipub-tooltip>
          <div class="ipub-p2 mar-b-10">If you have received a discount code , please enter it below. Once validated, discounts will be applied to the invoice upon submission.</div>
          <div v-if="hasDiscount">
            <div class="flex ipub-p2 mar-b-10">
              <ipub-input placeholder="Enter discount code"
                          style="width:calc(100% - 300px)"
                          v-model="discountCode" />
              <ipub-button @click="AddDiscount"
                           style="width:100px"
                           class="mar-l-10"
                           type="primary">
                <span class="ipub-p1">Save</span>
              </ipub-button>
              <ipub-button @click="selectDiscount"
                           style="width:190px"
                           class="mar-l-10"
                           type="primary">
                <span class="ipub-p1">Select My Voucher</span>
              </ipub-button>
            </div>
            <div>
              <ipub-label :style="{margin: '0 16px 16px 0'}"
                          v-for="(item, index) in discountCodeList"
                          :key="'detail.keywords'+index"
                          size="common"
                          cover
                          circle>
                $ {{item.discount}} off
                <a @click="delDiscount(index)"
                   class="mar-l-12">
                  <ipub-icon type="iconClose" />
                </a>
              </ipub-label>
            </div>
          </div>
        </div>
      </div>

      <div class="mar-b-20">
        <ipub-radio :checked="hasFoun"
                    class="mar-b-10 ipub-p1"
                    @change="onHasFunChange"
                    label="I have recevied funding" />
        <div v-if="hasFoun">
          <div class="mar-b-10">
            Funding data are used by funders to track the publications that result from their grants.
            IMR press can contribute to improve information for funders by
            depositing metadata through.
            <a target="_blank"
               href="https://www.crossref.org/education/funder-registry/"
               class="link-color">Crossref</a>
          </div>

          <ipub-form-item prop="foundation"
                          label="Funder">
            <ipub-input placeholder="The name of your funder"
                        :select="founds"
                        @input="getFound"
                        @select="onFoundationChange"
                        optionKey="name"
                        v-model.trim="foundation.name" />
          </ipub-form-item>

          <ipub-form-item prop="foundationNumber"
                          label="Grant Number">
            <div class="flex"
                 style="justify-content: space-between;">
              <ipub-input placeholder="Grant Number"
                          style="width:calc(100% - 82px)"
                          v-model.trim="foundation.code" />
              <ipub-button @click="AddFoun"
                           style="padding:0 20px"
                           class="mar-l-10"
                           type="primary">
                <span class="ipub-p1">Save</span>
              </ipub-button>
            </div>

          </ipub-form-item>

          <div>
            <ipub-label :style="{margin: '0 16px 16px 0'}"
                        v-for="(item, index) in params.foundationList"
                        :key="'detail.keywords'+index"
                        size="common"
                        cover
                        circle>
              {{item.name}} <template v-if="item.code">({{item.code}})</template>
              <a @click="delFoun(index)"
                 class="mar-l-12">
                <ipub-icon type="iconClose" />
              </a>
            </ipub-label>
          </div>
        </div>
      </div>

      <ipub-form-item prop="agreement">
        <div class="flex ipub-p1">
          <ipub-radio :checked="flag"
                      @change="onFlagChange(!flag)" />
          <span>
            <font class="key-color ipub-p2">*</font> I have read the
            <a @click="goToPage('authorGuide')"
               target="_blank"
               class="link-color">Instructions for Authors</a>, and prepared my manuscript as required. I agree with that my article will be published under an
            <a @click="goToPage('openAccessLink')"
               target="_blank"
               class="link-color">Open Access license.</a>
          </span>
        </div>
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <!-- <ipub-button plain
                   style="width:150px"
                   @click="() => { $router.back(-1)}"
                   type="primary">Back</ipub-button> -->
      <ipub-button style="width:150px;"
                   @click="submit"
                   :disabled="!flag"
                   type="primary">Save & Next</ipub-button>
    </div>
    <select-voucher :isVisable="isVisable"
                    @cancel="cancel"
                    :inputData="discountCodeList"
                    @confirm="confirmDiscount"></select-voucher>
    <!--              -->

  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
